var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _g4, _path9, _path10, _path11, _g5, _path12, _g6, _path13, _g7, _path14, _g8, _path15, _g9, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g10, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g11, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g12, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g13, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g14, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g15, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlumserberg = function SvgFlumserberg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 504 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flumserberg_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m426.353 102.67-.62-2.04-.51-2.47-.53-3.9-.34-3.02-.55-3.55-.28-2.79-.33-2.67.41-1.7 1.28-.89 1.22.19 1.17.41 1.61.61.85.55-.14-1 .08-1.08.29-.73.47-.66.7-.31 1.03-.06 1.53.29 1.25.45 1.4.83 1.13.81 1.24.91 1.39 1.14 1.28 1.05 1.03 1 1.71 2.07 1.32 1.95 1.52 2.3 1.6 2.81.95 2.11.74-1.17 1.22-1.71 1.84-2.59 2.13-3.34 1.23-2.11 1.35-2.11 1.03-1.64.74-1.24.7-.83 1.21-.81 1.03.39.68.59.88 1.15.41-1.22.69-1.03.86-.89.93-.56 1.36-.16 1.21.4.97 1.03.76 1.05.5 1.25.54 1.43.45 1.21.45 2.27.27 3.61-.05 3.75-.64 3.86-.51 2.74-.72 2.68-1.38 2.84 1.64-.62 1.66-.23.71.12.56.6.23.95-.18.96-.41.77.79-.14 1.48-.39 1.75-.35 1.59-.39 1.77-.41 1.89-.36 1.99-.25 1.94-.26h1.9l2.29.18 1.77.21 2.06.59 1.64.59 1.91.76 1.49.89 1.31.74.54.67.06.98-.37.82-.96.97-2.2 1.54-3.66 2.01-4.39 2.5-4.71 2.55-5.51 2.69-3.17 1.34 1.63.14 1.73.18 1.1.49.72.72.1.88-.14.65-.56.57-.67.66 1.71.79 1.56.76 1.65.74 2.12 1 2.11 1.07 2.51 1.48 2.09 1.58 1.92 1.79 1.4 1.35 1.54 2.03 1.44 2.19.7 1.46.76 1.96.65 1.89.04 1.32-.51.9-1.08.71-1.15.27-1.18.06-1.13-.12-.69-.49-.53 1.23-.81.41-1.02.2-1.28-.05-1.5-.14-1.53-.49-2.86-.82-2.59-1.01-2.81-.9-2.17-.69-1.91-.4-2.09-.28.77 1.96.6 1.7.77 2.43.36 1.87.21 1.8.23 1.79.1 1.81.03 1.64-.08 1.21-.08 1.37-.37 1.26-.6 1.38-.73 1.66-.84 1.5-1 1.84-.94 1.31-.98.83-.94.52-.8-.02-.29-.76-.35.9-.48 1.22-.76.88-.94-.19-.89-.48-1.02-.74-.75-.69-1.99-1.68-2.11-2.78-1.49-2.38-1.64-2.86-1.37-2.11-1.09-1.78-1.62-1.92-.35 1.24-.54 1.41-.84 1.67-1.75 2.99-1.69 2.73-1.53 2.28-1.35 1.93-1.7 1.8-1.79 1.61-1.27 1-1.54.93-2.25 1.04-1.26.23-.63-.26.2-.54-1.28.94-1.17.55-1.5.62-1.1.33-1-.13-.95-1.08-.15-1.21-.02-1.03.2-2.3.21-3.06.19-2.55.13-3.06.14-2.55-.05-1.83-.14-1.6-.88.78-.89.74-1.15.27-1.02-.33-.55-.61-.48-.89-.28-1.3-.4-1.3-2.52 1.5-1.57.96-2.53 1.29-3.14 1.51-2.38 1.02-2.32 1.15-2.11.68-1.63.54-1.16.41-1.5.33-.9.09-1.14.07-1.04-.26-.68-.16-.74-.92.34-1.32 1.21-2.52 1.56-2.53 1.49-2.99 1.44-2.59 1.23-2.06 1.49-2.1 1.03-1.58 1.16-1.18 1.55-1.82-1.33.11-.68-.06-.81-.48-.34-.74.19-.96.48-.89.54-1.35-1.06-.08-1.65-.02-2.03-.48-1.49-.33-1.66-.4-1.98-.22-1.91-.27-1.98-.46-1.58-.14-1.9-.2-1.91-.48-1.83-.28-.96-.55-.96-.95-.26-1.15.8-1.17.82-.88 1.16-1.17 2.3-1.16 2.5-1.5 2.14-1.24 2.51-1.28 2.06-.89 2.46-.57 2.56-.81 1.59-.08 2.16-.2-.77-1.09-.55-.88-.28-.88.05-.95.27-.62.42-.35 1.09-.79-.67-.63-1.22-.96-1.22-1.36-1.84-1.65-1.83-2.17-1.24-1.91-1.09-2.27-.98-2.72-.4-1.9-.54-1.45-.53-1.69-.27-1.78.18-.87.76-.44 1.15-.34 1.84.06 1.37.13 1.55.47-.22-.17-.42-.4-.33-.48-.12-.23.09-.92.45-.73.9-.43 2.15.07 1.89.51 2.49.71 2.91.91 3.26 1.01 2.6.93 1.43.5.9.46.9.44.41.42.49.53.67.2ZM10.163 20.21c.73-3.28 3.62-6.24 7.62-6.24h20.48c3.52 0 4.76 2.72 4.14 5.52-.6 2.72-2.98 5.52-6.58 5.52h-14.72l-2.59 11.68h12.4c3.84 0 5.16 2.72 4.55 5.44-.62 2.8-3.16 5.6-7 5.6h-12.4l-3.86 17.44c-.89 4-3.94 6.24-7.38 6.24s-5.5-2.24-4.62-6.24l9.96-44.96ZM56.463 19.73c.89-4 3.94-6.24 7.38-6.24s5.5 2.24 4.62 6.24l-8.9 40.16h14.24c4.08 0 5.17 3.04 4.48 5.76-.75 2.64-3.41 5.28-6.93 5.28h-20c-3.92 0-5.67-2.56-4.79-6.56l9.89-44.64h.01ZM96.293 19.73c.89-4 3.94-6.24 7.38-6.24s5.5 2.24 4.62 6.24l-6.19 27.92c-1.63 7.36 1.79 13.2 9.39 13.2 7.6 0 13.61-6.16 15.17-13.2l6.19-27.92c.89-4 3.94-6.24 7.38-6.24s5.5 2.24 4.62 6.24l-6.33 28.56c-2.98 13.44-16.27 23.6-29.47 23.6s-22.1-10-19.09-23.6l6.33-28.56ZM322.673 21.01c-.69 3.12-3.39 5.92-6.67 5.92s-5.31-2.4-10.11-2.4c-3.44 0-6.97 1.84-7.71 5.2-1.83 8.24 26.06 2.96 21.49 23.6-2.53 11.44-13.55 18.56-24.59 18.56-6.16 0-19.12-1.44-17.46-8.96.69-3.12 3.34-5.68 6.62-5.68 3.76 0 7.55 3.12 12.75 3.12s8.82-2.96 9.68-6.88c2.09-9.44-25.89-3.76-21.77-22.32 2.48-11.2 13.22-18.16 23.87-18.16 4.48 0 15.31 1.68 13.91 8h-.01ZM341.223 20.93c.89-4 3.54-6.96 7.78-6.96h19.84c3.84 0 5.08 2.72 4.46 5.52-.6 2.72-3.14 5.52-6.9 5.52h-14.08l-2.59 11.68h13.12c3.92 0 5.24 2.72 4.62 5.52-.6 2.72-3.22 5.52-7.06 5.52h-13.12l-2.7 12.16h14.8c3.84 0 5.08 2.72 4.46 5.52-.6 2.72-3.14 5.52-6.9 5.52h-20.64c-3.52 0-5.63-2.4-4.83-6l9.75-44h-.01ZM389.103 20.21c.85-3.84 3.54-6.24 7.54-6.24h14.08c12.32 0 18.7 5.52 15.91 18.08-1.95 8.8-9.71 13.84-18.15 15.12l10.37 14.56c.85 1.2 1.07 2.4.82 3.52-.69 3.12-3.85 6.16-7.37 6.16-1.44 0-3.24-.56-4.18-2.08l-12.99-21.52h-.16l-3.85 17.36c-.89 4-3.94 6.24-7.38 6.24s-5.5-2.24-4.62-6.24l9.96-44.96h.02Zm7.8 18.96h8.24c4.4 0 8.03-2.64 9.02-7.12 1.01-4.56-1.48-7.04-5.88-7.04h-8.24l-3.14 14.16ZM168.473 91.22c.85-3.84 3.97-6 7.65-6h15.36c8.32 0 13.8 5.6 11.92 14.08-1.24 5.6-4.39 9.36-10.05 11.76l-.04.16c6.59.96 10.69 6.64 9.15 13.6-2.5 11.28-11.37 17.36-22.41 17.36h-16.48c-3.68 0-5.89-2.32-5.05-6.08l9.95-44.88Zm8.33 16.56h6.24c3.92 0 6.99-2.32 7.88-6.32.83-3.76-1.7-5.68-5.22-5.68h-6.24l-2.66 12Zm-5.28 23.84h9.44c4.32 0 8.07-2.48 9.06-6.96.83-3.76-1.48-6.32-7.08-6.32h-8.48l-2.94 13.28ZM222.023 92.18c.89-4 3.54-6.96 7.78-6.96h19.84c3.84 0 5.08 2.72 4.46 5.52-.6 2.72-3.14 5.52-6.9 5.52h-14.08l-2.59 11.68h13.12c3.92 0 5.24 2.72 4.62 5.52-.6 2.72-3.22 5.52-7.06 5.52h-13.12l-2.7 12.16h14.8c3.84 0 5.08 2.72 4.46 5.52-.6 2.72-3.14 5.52-6.9 5.52h-20.64c-3.52 0-5.63-2.4-4.83-6l9.75-44h-.01ZM269.903 91.46c.85-3.84 3.54-6.24 7.54-6.24h14.08c12.32 0 18.7 5.52 15.91 18.08-1.95 8.8-9.71 13.84-18.15 15.12l10.37 14.56c.85 1.2 1.07 2.4.82 3.52-.69 3.12-3.85 6.16-7.37 6.16-1.44 0-3.24-.56-4.18-2.08l-12.99-21.52h-.16l-3.85 17.36c-.89 4-3.94 6.24-7.38 6.24s-5.5-2.24-4.62-6.24l9.96-44.96h.02Zm7.8 18.96h8.24c4.4 0 8.03-2.64 9.02-7.12 1.01-4.56-1.48-7.04-5.88-7.04h-8.24l-3.14 14.16ZM364.203 108.42c5.04 0 6.47 2.56 5.34 7.68-3.42 15.44-16.07 27.04-32.07 27.04s-24.67-12.88-21-29.44c3.69-16.64 17.73-29.44 34.05-29.44 12.08 0 20.74 5.68 19.5 11.28-.76 3.44-3.4 5.6-6.2 5.6-5.44 0-5.27-5.84-15.75-5.84s-16.97 8.72-19.12 18.4c-2.16 9.76.8 18.4 10.96 18.4 6.32 0 14.38-3.52 16.4-12.64h-8.16c-3.28 0-5.09-2.32-4.36-5.6.75-3.36 3.77-5.44 6.81-5.44h13.6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.093 151.05c-2.19 3.46-1 6.27 2.23 7.43 3.24 1.16 6.87.09 9.06-3.38l82.31-131.03 20.86 50.68 25.97-51.71 21.75 44.35c1.8 3.68 5.3 5.13 8.65 4.32 3.34-.81 4.82-3.47 3.02-7.15L233.693 1s-.46-1-1.38-1c-.92 0-1.31 1-1.31 1l-24.28 45.75L187.823 1s-.62-.94-1.31-.94c-.69 0-1.31.94-1.31.94l-94.11 150.05ZM405.883 107.25s-3.12-5.72-2.12-6.88c1.12-1.31 1.38-2.25 12.88 2s17.75 4.25 17.75 4.25-8.91-22.82-5.88-24.75c4.44-2.81 8.75-.12 14.12 7.88 5.37 8 9 16 9 16L462.753 83s2.31-3.94 5.12-3.25c2.68.66 5.75 4.12 4.38 11.88-1.37 7.76-3.12 14-3.12 14s2.56-1.19 3.88.12c.96.96.38 4.5.38 4.5s5.77-2.29 10.38-2.75c4.37-.44 13.56-1.94 16.12 2.5.96 1.66-.31 3.75-1.5 4.56-.98.67-19.75 9.94-19.75 9.94l-5.38 2.5s8.44-.19 8.94 1.31-.44 2.12-.81 2.5c-.59.59-1.12.81-1.12.81s15.51 5.81 19.69 13.12c.75 1.31 4.12 6.81 1.62 8.25-2.5 1.44-21.94-3.62-21.94-3.62l-4.25.12 1.04 3.31s2.26 9.13 2.15 15.5c-.08 4.81-4.44 8.75-6.56 9.19-1.75.36-9.88-11.75-9.88-11.75l-7-4.62-.62 1.25s-6.02 13.32-8 15.25c-2.25 2.19-6.25 5.5-8.5 4.88-2.25-.62-4-6-4-6l-7.75-50.12-20.38-19.12-.01-.01Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M447.383 102.5s3.19-5.88 4.5-7.44c1.31-1.56 5.56-8.06 6.12-9 .56-.94 2.19-5.31 3.62-5 1.44.31 3.44 1.62 4.06 4.56.62 2.94 2.25 8.5 1.19 13.75s-4.56 16.12-4.56 16.12l-5.81 3.56-6.5.75-1.31-2.44-2.88-4.75v-4.38l1.56-5.75.01.02Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.013 100.44c1.54-4.98 3.31-12.75 1.94-12.62-.41.04-1.74 7.29-3.72 12.11-2.01 4.89-5.37 12.64-3.35 11.07.33-.25 3.58-5.58 5.12-10.56h.01Z",
    fill: "currentColor"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.763 87.25c-1.12 3.57-1.93 10.64-1.5 10.81.43.17 2.08-6.34 3.31-9.87 1.38-3.94 1.62-6.71 1.19-6.87-.43-.17-1.75 1.94-3 5.94v-.01ZM459.693 98.62s2.5-8.94 2.69-11c.19-2.06.25-4.88.25-4.88s4.31 4.12 4 12.5c-.22 5.88-1.06 6.88-1.06 6.88s-.75-4.81-2.06-5.56-3.81 2.06-3.81 2.06h-.01ZM471.763 147.92s6.33 2.15 8.35 2.41c2.02.26 9.56 2.15 10.61 2.45 1.05.3 5.21 2.42 6.06 1.21.85-1.21 1.42-3.53-.11-6.11-1.53-2.58-4.12-7.77-8.46-10.9-4.34-3.13-14.29-8.75-14.29-8.75l-6.69 1.33-5.28 3.86.69 2.68 1.11 5.44 2.97 3.21 5.05 3.16-.01.01Z",
    fill: "currentColor"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.693 141.54c4.51 2.61 11.09 7.12 9.99 7.96-.33.25-6.23-4.17-10.95-6.37-4.79-2.23-12.52-5.64-9.97-5.86.41-.04 6.42 1.67 10.93 4.28v-.01Z",
    fill: "currentColor"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490.463 151.4c-3.25-1.87-8.65-6.5-8.44-6.92.21-.42 5.83 3.25 9.13 5 3.68 1.96 5.74 3.83 5.54 4.24-.2.41-2.6-.24-6.23-2.32ZM483.433 142.41s7.9 4.87 9.44 6.26c1.54 1.39 3.49 3.41 3.49 3.41s.37-5.96-5.55-11.9c-4.15-4.17-5.45-4.33-5.45-4.33s2.72 4.04 2.26 5.49c-.45 1.44-4.2 1.07-4.2 1.07h.01ZM414.203 146.77s-4.02 5.34-4.9 7.18c-.88 1.84-5.03 8.41-5.65 9.31-.62.9-3.93 4.19-3.05 5.37.88 1.18 2.9 2.45 5.84 1.8 2.93-.65 8.67-1.48 13-4.62 4.34-3.14 12.78-10.84 12.78-10.84l.83-6.77-2.01-6.23-2.76-.18-5.51-.65-3.98 1.81-4.58 3.81-.01.01Z",
    fill: "currentColor"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.153 158.2c-3.89 3.47-10.23 8.3-10.68 7-.14-.39 5.91-4.61 9.48-8.41 3.62-3.85 9.27-10.13 8.69-7.64-.09.4-3.6 5.58-7.49 9.04v.01Z",
    fill: "currentColor"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405.053 163.44c2.79-2.5 8.88-6.18 9.22-5.85.34.33-4.91 4.52-7.61 7.11-3.01 2.88-5.43 4.26-5.76 3.93-.33-.33 1.04-2.4 4.16-5.19h-.01ZM415.793 159.58s-7.1 5.98-8.89 7.01c-1.79 1.03-4.33 2.25-4.33 2.25s5.54 2.21 13.03-1.54c5.26-2.64 5.82-3.82 5.82-3.82s-4.69 1.31-5.92.43c-1.23-.88.3-4.32.3-4.32l-.01-.01ZM423.963 110.44s-5.83-3.06-7.77-3.66c-1.94-.6-9-3.65-9.98-4.11-.98-.46-5.84-1.68-6.88-.77-1.04.91-.88 1.43.16 3.99 1.04 2.56 2.64 7.61 6.34 11.17 3.7 3.56 12.47 10.34 12.47 10.34l6.81.06 5.89-2.43-.19-2.49-.11-5-2.34-3.38-4.39-3.72h-.01Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.343 107.7c6.75 7.78 20.05 11.96 19.69 11.72-1.24-.81-16.03-9.7-18.1-12.7-2.3-3.34-4.27-5.09-4.61-4.82-.34.27-1.65.41 3.02 5.8Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M417.393 107.5s-8.54-2.75-10.27-3.68c-1.73-.93-7.8-1.93-7.8-1.93s4.43 4.94 11.19 9.03c4.75 2.87 6.04 2.76 6.04 2.76s-3.32-3.04-3.11-4.41c.21-1.37 3.94-1.78 3.94-1.78l.01.01Z",
    fill: "currentColor",
    opacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.873 114.53c-4.15-2.4-14.77-12.26-13.54-12.8.37-.16 10.7 8.31 14.95 11.11 4.31 2.85 11.29 7.27 8.74 7-.41-.04-5.78-2.79-10.15-5.31Z",
    fill: "currentColor"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M454.813 158.03s3.08 5.82 4.34 7.41c1.26 1.59 5.36 8.1 5.9 9.04.54.94 3.87 4.68 5.24 4.53 1.37-.15 1.54-.68 2.12-3.38.58-2.7 2.12-7.77 1.08-12.8-1.04-5.03-4.43-15.58-4.43-15.58l-5.58-3.9-6.23-1.32-1.25 2.16-2.74 4.19.02 4.11 1.52 5.55.01-.01Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M471.093 172.52c-1.16-10.23-9.78-21.21-9.61-20.81.56 1.37 7.73 17.07 7.74 20.71 0 4.05.64 6.61 1.08 6.59.44-.02 1.6.6.79-6.49Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M458.573 164.18s5.48 7.1 6.39 8.84c.91 1.74 5.34 6 5.34 6s-.86-6.58-4.12-13.77c-2.29-5.06-3.42-5.69-3.42-5.69s1.02 4.39.07 5.39-4.26-.76-4.26-.76v-.01Z",
    fill: "currentColor",
    opacity: 0.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.273 160.94c2.06 4.32 5.24 18.47 3.93 18.22-.4-.07-4.13-12.9-6.04-17.62-1.94-4.78-5.2-12.38-3.25-10.72.31.27 3.19 5.57 5.37 10.12h-.01Z",
    fill: "currentColor"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M427.473 109.33s-1.55-6.49-1.63-8.53c-.08-2.04-1.28-9.7-1.49-10.78-.21-1.08-1.9-5.4-.67-6.14 1.23-.74 3.52-1.12 5.88.63s7.15 4.76 9.82 9.36 7.26 14.99 7.26 14.99l-1.83 6.55-4.16 4.94-2.53-.92-5.15-1.57-2.85-3.23-2.63-5.3h-.02Z",
    fill: "currentColor"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.443 99.97c-2.14-4.72-5.95-11.65-6.85-10.63-.27.31 3.51 6.56 5.24 11.45 1.76 4.96 4.4 12.96 4.83 10.44.07-.41-1.08-6.54-3.23-11.26h.01Z",
    fill: "currentColor"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M424.543 93.94c2.34 10.18 6.68 5.62 7.1 5.45.42-.17-2.65-6.08-4.07-9.53-1.59-3.84-3.26-6.13-3.64-5.88-.97.64-.8 3.82.61 9.95v.01ZM413.043 144.56s-6.65-.4-8.64-.86c-1.99-.46-9.68-1.47-10.77-1.57-1.09-.1-5.69.18-6.09-1.05-.4-1.23-.17-3.25 2.12-4.78 2.29-1.53 6.43-4.76 11.54-5.8 5.11-1.03 16.31-2.17 16.31-2.17l5.84 3.26 3.69 4.79-1.53 1.88-2.84 3.92-3.85 1.55-5.79.82.01.01Z",
    fill: "currentColor"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.813 136.25c-5.1.56-12.76 1.94-12.01 2.97.23.31 7.22-1.23 12.39-1.4 5.24-.17 13.62-.3 11.3-1.32-.38-.17-6.58-.81-11.68-.24v-.01Z",
    fill: "currentColor"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M397.463 142.99c10.41.71 7.13-4.14 7.08-4.54-.05-.4-6.54.63-10.23.92-4.1.33-6.74 1.13-6.6 1.51.37.98 3.48 1.67 9.75 2.1v.01ZM475.383 127.71s6.02-2.9 7.65-4.13c1.62-1.23 8.33-5.16 9.29-5.68.96-.52 5.41-1.92 5.17-3.38-.24-1.46-1.45-3.51-4.36-4.28-2.91-.77-8.38-2.66-13.68-1.86-5.3.8-16.33 3.77-16.33 3.77l-3.84 5.63-1.07 6.46 2.37 1.43 4.6 3.1 4.37.21 5.82-1.28.01.01Z",
    fill: "currentColor"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.013 116.2c4.97-1.55 19.18-3.82 18.99-2.45-.06.41-13.65 2.52-18.57 4.25-4.98 1.76-18.43 8.59-16.77 6.64.27-.31-1.24-2.95 16.35-8.44Z",
    fill: "currentColor"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M483.513 123c7.75-6.5-3.6-4.56-3.75-5-.15-.44 6.98-1.7 10.57-2.76 4-1.18 7.53-1.18 7.68-.74.15.44-10.12 6.75-14.5 8.5ZM479.863 115.6s9.05-2.06 11.12-2.14c2.07-.08 4.88-.01 4.88-.01s-3.91-4.51-12.29-4.61c-5.89-.07-12.94 1.91-12.94 1.91s4.69 1.91 6.12 2.38c3.88 1.25 3.1 2.48 3.1 2.48l.01-.01ZM432.153 158.08s-1.13 6.59-1.07 8.63c.06 2.04-.62 9.78-.76 10.86s-1.57 5.53-.25 6.17c1.32.64 3.71.85 6.01-1.07s7.03-5.28 9.44-10.06c2.42-4.78 6.4-15.49 6.4-15.49l-2.36-6.4-4.64-4.61-2.54 1.1-5.2 1.95-2.71 3.44-2.33 5.48h.01Z",
    fill: "currentColor"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#flumserberg_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.003 166.9c-1.62 4.95-8.01 17.85-9.01 16.9-.3-.28 5.87-12.58 7.3-17.6 1.45-5.08 3.69-20 4.31-17.51.1.4 3.12.7-2.6 18.21Z",
    fill: "currentColor"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M431.283 167.43c.8 10.08 5.8-.29 6.25-.16.45.13-2.66 6.67-3.88 10.21-1.36 3.94-3.4 6.83-3.85 6.69-.45-.14.37-12.16 1.48-16.74ZM439.423 168.75s-3.57 8.57-4.7 10.3c-1.13 1.73-2.82 3.98-2.82 3.98s5.94-.57 10.88-7.34c3.47-4.76 5.95-11.65 5.95-11.65s-4.27 2.71-5.49 3.61c-3.27 2.43-3.82 1.09-3.82 1.09v.01Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.763 99.5c.94-1.27 2.81 1.7 2.96 2.19 1.11 3.57.26 7.39 1.1 10.94.31-1.34 2-2.05 3.21-1.43.33.17.62.42.93.64.98.67 2.19.93 3.35 1.17 2.59.53 5.44 1.02 7.77-.22.31-.17.73 4.76.42 5.4-.86 1.81-3.84 2.83-5.16 4.39-.32.38-.64.85-.54 1.35.09.41.44.7.78.94.89.62 1.86 1.14 2.87 1.52.8.3 1.63.52 2.41.87 2.04.91 7.28 5.06 6.67 7.75-.23 1.01-.43 2.05-.79 3.02-.25.67-.66 1.32-1.31 1.63-.61.3-1.32.26-2 .2l-5.61-.42c-.29-.02-.62-.03-.84.16-.52.47 4.41 4.37 4.86 4.74 1.7 1.44.21 3.49-.65 5.59-.61 1.48-.54.13-1.62 1.18-1.23 1.19-1.28 5.25-2.27 6.65-.17.24-.36.49-.64.55-.35.08-.68-.15-.97-.37-1.67-1.29-3.44-2.55-4.94-4.05-.9-.86-1.94-2.34-3.3-2.34.54.01 1.06 3.17 1.1 3.64.26 2.58-.44 4.99-1.23 7.41-.05.16-.11.34-.25.44-.21.17-.51.12-.77.06-1.31-.27-2.7-.37-3.95.08-1.08.38-1.99 1.14-3.03 1.62-1.68.77-3.88.09-5.12-1.2-1.57-1.63-.96-3.96-1.85-5.88-.31-.68-1.03-1.32-1.73-1.07-.58 1.88-1.1 3.94-2.19 5.61-1.53 2.34-5.19 4.53-7.95 4.78-.17.02-.38 0-.48-.14-.06-.1-.05-.23-.03-.34.72-5.04 1.46-10.08 2.2-15.12.11-.72.21-1.46.11-2.18-.09-.62-.33-1.22-.56-1.8-1.84-4.55-3.68-9.1-5.51-13.65l-11.58-9.61s-.92-1.08.83-2.06 4.33-1.14 5-.98c.67.16 5.08.98 5.08.98s-2.17.52-3.08-1.39c-.78-1.63-3.06-3.83-2.31-5.79.21-.56.6-1.03 1-1.46.84-.9 1.82-1.68 2.88-2.3 1.1-.64 2.31-1.14 3.21-2.03.65-.64 1.14-1.58 1.07-2.51-.02-.29-.91-2.12-.19-1.91.83.25 2 .75 3.42 1.66 1.42.91 4 4.58 4.67 5 .67.42 2.58 4.36 2.58 4.36s11.87-16.14 11.97-16.27Z",
    fill: "currentColor",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M437.193 109.78s2.62-4.62 3.97-6.69c1.35-2.07 4.91-8.44 7.44-2.41 2.53 6.03 4.81 12.12 4.81 12.12l-16.22-3.03v.01Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M437.193 109.78s2.46-4.54 3.85-6.57c1.39-2.02 2.65-4.56 4.94-5.12-1.85.4-8.79 11.7-8.79 11.7v-.01Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M444.763 103.94c-.22 3.13-.3 7.06-.03 7.09.72.09 1.63-4.06 1.84-7.19.21-3.13.25-5.78-.66-5.66-.27.03-.93 2.63-1.15 5.76ZM449.333 104.67c1.13 2.92 3.35 6.46 3.46 6.71.53 1.28-1.55-4.11-2.69-7.03s-2.11-5.24-2.37-5.15c-.26.09.46 2.55 1.6 5.47Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M447.473 98.55h-11v13h11v-13Z",
    fill: "url(#flumserberg_svg__k)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M438.293 109.22s4.69-8.53 5.41-8.06c.72.47 1.38 3.62.44 4.75s-5.84 3.31-5.84 3.31h-.01Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M455.473 103.55h-11v11h11v-11Z",
    fill: "url(#flumserberg_svg__l)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M452.823 112.16c-.75-1.22-2.69-4.53-3.84-5.41-1.35-1.02-2.44-.66-2.34.69.09 1.34 2.09 2.81 3.38 3.41 1.28.59 2.81 1.31 2.81 1.31h-.01Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M449.473 95.55h-7v18h7v-18Z",
    fill: "url(#flumserberg_svg__m)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M445.133 103.89c-.22 3.13-.75 6.98-.13 7.04.62.06.92-4.06 1.14-7.19.22-3.13.52-5.55 0-5.62-.25-.03-.78 2.64-1 5.77h-.01ZM423.933 119.25s-1.27-5.22-1.7-7.67c-.43-2.45-2.22-9.61 3.81-6.92 6.04 2.69 11.93 5.6 11.93 5.6l-14.04 8.99Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M423.933 119.25s-1.33-5.05-1.71-7.5c-.38-2.45-1.21-5.19.09-7.19-1.09 1.57 1.62 14.69 1.62 14.69Z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M425.463 109.72c2.01 2.45 4.66 5.41 4.88 5.24.59-.44-1.61-4.12-3.61-6.57-2.01-2.45-3.81-4.43-4.41-3.71-.17.21 1.13 2.58 3.14 5.03v.01ZM429.333 107.09c2.86 1.37 6.94 2.44 7.18 2.55 1.28.58-3.99-1.95-6.84-3.32-2.86-1.37-5.18-2.4-5.3-2.15-.12.25 2.1 1.55 4.96 2.92Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M429.473 106.55h-9v14h9v-14Z",
    fill: "url(#flumserberg_svg__n)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M424.353 118.08s-2.45-9.52-1.6-9.68c.85-.16 3.52 1.72 3.61 3.19.09 1.47-2.01 6.48-2.01 6.48v.01Z",
    fill: "currentColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M439.473 106.55h-13v8h13v-8Z",
    fill: "url(#flumserberg_svg__o)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M437.083 110.19c-1.4-.38-5.11-1.48-6.57-1.32-1.7.18-2.25 1.2-1.25 2.13 1 .93 3.49.62 4.84.17 1.35-.45 2.98-.98 2.98-.98Z",
    fill: "currentColor"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.473 102.55h-13v15h13v-15Z",
    fill: "url(#flumserberg_svg__p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.703 109.43c2.01 2.45 4.28 5.66 4.78 5.28.5-.38-2.13-3.63-4.14-6.08s-3.46-4.45-3.89-4.13c-.21.15 1.25 2.48 3.25 4.94v-.01Z",
    fill: "currentColor"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M419.633 134.29s-4.46-3.1-6.43-4.66c-1.97-1.56-8.12-5.78-1.7-7.72 6.42-1.94 12.88-3.62 12.88-3.62l-4.75 16Z",
    fill: "currentColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M419.633 134.29s-4.39-2.93-6.32-4.53c-1.92-1.6-4.39-3.12-4.73-5.48.22 1.9 11.06 10.01 11.06 10.01h-.01Z",
    fill: "currentColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M414.433 126.11c3.17.53 7.18 1.01 7.24.74.16-.72-3.98-2.04-7.15-2.57-3.17-.53-5.88-.83-5.85.1 0 .27 2.59 1.2 5.76 1.73ZM415.643 121.58c3.1-.85 6.94-2.72 7.2-2.8 1.36-.41-4.35 1.15-7.46 2-3.1.85-5.57 1.6-5.5 1.86.07.26 2.65-.21 5.75-1.06h.01Z",
    fill: "currentColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M421.463 124.54h-12v11h12v-11Z",
    fill: "url(#flumserberg_svg__q)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M419.163 133.14s-8.24-5.57-7.69-6.24c.55-.67 3.84-1.02 4.9.04 1.06 1.06 2.79 6.21 2.79 6.21v-.01Z",
    fill: "currentColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M426.463 116.54h-12v11h12v-11Z",
    fill: "url(#flumserberg_svg__r)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M423.643 118.83c-1.32.63-4.9 2.25-5.91 3.32-1.18 1.25-.92 2.38.46 2.42 1.38.04 3.09-1.82 3.82-3.05.73-1.23 1.63-2.7 1.63-2.7v.01Z",
    fill: "currentColor"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.463 121.54h-18v8h18v-8Z",
    fill: "url(#flumserberg_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.423 125.73c3.17.53 7.06 1.45 7.18.84.12-.61-4.06-1.33-7.23-1.86-3.17-.53-5.62-1.08-5.74-.55-.06.25 2.62 1.05 5.79 1.58v-.01Z",
    fill: "currentColor"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M427.493 147.38s-8.06 1.58-10.57 1.68c-2.51.1-9.92.9-6.31-4.75 3.61-5.65 8.48-10.94 8.48-10.94l8.4 14.02v-.01Z",
    fill: "currentColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M427.493 147.38s-7.89 1.67-10.4 1.71c-2.5.04-5.36.49-7.16-1.08 1.4 1.31 17.56-.63 17.56-.63Z",
    fill: "currentColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.563 145.58c2.75-1.66 6.11-3.91 5.98-4.15-.34-.65-4.35 1.04-7.11 2.7-2.76 1.66-5.01 3.2-4.38 3.88.18.2 2.75-.77 5.5-2.44l.01.01ZM413.543 141.36c1.8-2.66 5.41-7.76 5.56-7.99.77-1.19-4.47 4.88-6.27 7.55-1.8 2.66-3.19 4.84-2.96 4.99.23.15 1.87-1.88 3.68-4.54l-.01-.01Z",
    fill: "currentColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M429.463 142.54h-15v8h15v-8Z",
    fill: "url(#flumserberg_svg__t)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M426.533 147.17s-9.88 1.13-9.9.26c-.02-.87 2.25-3.27 3.74-3.16 1.49.11 6.16 2.9 6.16 2.9Z",
    fill: "currentColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M422.463 131.54h-8v13h8v-13Z",
    fill: "url(#flumserberg_svg__u)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M419.023 133.49c-.59 1.34-2.26 4.9-2.33 6.37-.08 1.72.85 2.41 1.93 1.54 1.08-.87 1.16-3.39.92-4.8-.24-1.41-.52-3.11-.52-3.11Z",
    fill: "currentColor"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.463 138.54h-17v12h17v-12Z",
    fill: "url(#flumserberg_svg__v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.313 145.29c2.75-1.66 6.31-3.49 6-4.04-.31-.55-3.95 1.63-6.7 3.29-2.75 1.66-4.97 2.84-4.72 3.31.12.23 2.67-.9 5.42-2.57v.01Z",
    fill: "currentColor"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M440.713 151.99s-5.07 7.24-6.91 9.16c-1.84 1.92-6.93 8.02-7.89.58-.95-7.44-.72-15.5-.72-15.5l15.51 5.76h.01Z",
    fill: "currentColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M440.713 151.99s-4.89 7.19-6.77 9.06c-1.87 1.86-3.74 4.34-6.13 4.32 1.91.08 12.89-13.38 12.89-13.38h.01Z",
    fill: "currentColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M430.503 159.19c1-3.43 2.08-7.79 1.82-7.9-.69-.3-2.62 4.07-3.62 7.49s-1.71 6.38-.78 6.5c.27.04 1.58-2.67 2.58-6.09ZM426.213 157.08c-.37-3.58-.97-10.55-1.01-10.85-.2-1.58-.2 7.42.17 11s.74 6.44 1.01 6.41c.27-.03.19-2.97-.18-6.55l.01-.01Z",
    fill: "currentColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M442.363 150.43h-12v12h12v-12Z",
    fill: "url(#flumserberg_svg__w)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M439.853 152.51s-6.74 8.19-7.33 7.46c-.59-.73-.43-4.43.77-5.42 1.2-.99 6.56-2.04 6.56-2.04Z",
    fill: "currentColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M432.363 144.43h-9v13h9v-13Z",
    fill: "url(#flumserberg_svg__x)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M425.233 146.39c.43 1.57 1.48 5.81 2.39 7.11 1.06 1.52 2.22 1.42 2.47-.1s-1.34-3.73-2.44-4.75c-1.1-1.02-2.42-2.26-2.42-2.26Z",
    fill: "currentColor"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.363 149.43h-9v19h9v-19Z",
    fill: "url(#flumserberg_svg__y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.123 159.13c1-3.43 2.5-7.57 1.91-7.82-.59-.25-1.93 4.27-2.93 7.7-1 3.43-1.91 6.04-1.41 6.27.24.11 1.43-2.72 2.44-6.15h-.01Z",
    fill: "currentColor"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M455.023 147.14s.45 8.83.18 11.47c-.27 2.64-.53 10.59-5.86 5.31s-10.09-11.78-10.09-11.78l15.77-5Z",
    fill: "currentColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M455.023 147.14s.56 8.68.23 11.31c-.33 2.62-.28 5.72-2.18 7.17 1.56-1.11 1.94-18.48 1.94-18.48h.01Z",
    fill: "currentColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M451.393 159.1c-1.32-3.32-3.15-7.42-3.42-7.35-.73.18.43 4.82 1.75 8.14 1.32 3.32 2.57 6.08 3.38 5.61.24-.14-.39-3.08-1.71-6.39v-.01ZM446.723 160.08c-2.49-2.59-7.25-7.72-7.47-7.94-1.13-1.12 4.4 5.97 6.9 8.57 2.49 2.59 4.55 4.63 4.74 4.43.19-.2-1.68-2.46-4.17-5.05v-.01Z",
    fill: "currentColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M457.363 145.43h-9v16h9v-16Z",
    fill: "url(#flumserberg_svg__z)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M454.663 148.08s-.28 10.6-1.19 10.39c-.91-.21-3.06-3.23-2.72-4.75.34-1.52 3.91-5.64 3.91-5.64Z",
    fill: "currentColor"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M450.363 149.43h-13v10h13v-10Z",
    fill: "url(#flumserberg_svg__A)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M439.373 152.25c1.3.98 4.74 3.67 6.26 4.14 1.77.55 2.62-.24 1.88-1.6-.74-1.36-3.35-2.12-4.85-2.25-1.5-.13-3.3-.29-3.3-.29h.01Z",
    fill: "currentColor"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.363 149.43h-10v19h10v-19Z",
    fill: "url(#flumserberg_svg__B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.063 159.29c-1.32-3.32-2.69-7.51-3.3-7.34-.61.17 1.11 4.55 2.42 7.87 1.32 3.32 2.21 5.94 2.74 5.81.25-.06-.54-3.03-1.86-6.35v.01Z",
    fill: "currentColor"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M453.113 112.12s5.79-2.32 8.49-3.24c2.7-.92 10.64-4.16 7.5 2.97-3.14 7.13-6.52 14.14-6.52 14.14l-9.47-13.87Z",
    fill: "currentColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M453.113 112.12s5.6-2.36 8.31-3.22c2.7-.85 5.75-2.25 7.91-1.18-1.7-.92-16.23 4.4-16.23 4.4h.01Z",
    fill: "currentColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M463.563 112.11c-2.76 2.65-6.09 6.1-5.92 6.31.46.57 4.58-2.51 7.34-5.15 2.76-2.64 4.99-4.99 4.22-5.51-.23-.15-2.88 1.71-5.64 4.35ZM466.333 115.91c-1.59 3.39-2.89 8.08-3.02 8.37-.67 1.51 2.27-4.74 3.86-8.13 1.59-3.39 2.8-6.14 2.53-6.23-.27-.09-1.77 2.59-3.37 5.98v.01Z",
    fill: "currentColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M467.303 106.38h-15v10h15v-10Z",
    fill: "url(#flumserberg_svg__C)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M454.383 112.37s10.56-4.39 10.7-3.48c.14.91-2 4.18-3.63 4.54-1.63.36-7.07-1.06-7.07-1.06Z",
    fill: "currentColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M467.303 113.38h-8v14h8v-14Z",
    fill: "url(#flumserberg_svg__D)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M462.693 125c.46-1.6 1.78-5.9 1.65-7.47-.15-1.84-1.26-2.26-2.3-1-1.04 1.26-.79 3.95-.34 5.37s.99 3.11.99 3.11V125Z",
    fill: "currentColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M472.303 105.38h-17v16h17v-16Z",
    fill: "url(#flumserberg_svg__E)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M463.873 112.32c-2.76 2.65-6.36 5.72-5.95 6.2.41.48 4.06-3 6.82-5.64 2.76-2.64 5-4.6 4.66-5.02-.16-.2-2.77 1.82-5.53 4.46ZM461.503 123.66s6.02 1.48 8.74 2.31c2.72.83 11.01 2.82 4.33 6.75-6.67 3.93-13.47 7.63-13.47 7.63l.4-16.69Z",
    fill: "currentColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M461.503 123.66s5.89 1.34 8.58 2.23c2.68.88 5.95 1.52 7.07 3.64-.84-1.73-15.65-5.86-15.65-5.86v-.01Z",
    fill: "currentColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M469.943 129.71c-3.76.53-8.46 1.39-8.44 1.66.04.73 5.15.63 8.91.1s6.93-1.13 6.61-2c-.09-.26-3.31-.29-7.08.24ZM469.983 134.39c-3.25 1.81-7.02 4.84-7.3 5-1.42.83 4.58-2.51 7.83-4.32 3.25-1.81 5.82-3.33 5.65-3.56-.17-.23-2.94 1.06-6.19 2.88h.01Z",
    fill: "currentColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M475.303 122.38h-15v10h15v-10Z",
    fill: "url(#flumserberg_svg__F)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M462.383 124.6s11.07 2.58 10.66 3.4c-.41.82-4.04 2.22-5.56 1.56-1.52-.66-5.09-4.96-5.09-4.96h-.01Z",
    fill: "currentColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M470.303 130.38h-11v12h11v-12Z",
    fill: "url(#flumserberg_svg__G)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M461.763 139.61c1.3-1.03 4.86-3.73 5.67-5.08.95-1.57.3-2.56-1.28-2.14-1.58.42-2.93 2.73-3.38 4.14-.45 1.41-1.01 3.08-1.01 3.08Z",
    fill: "currentColor"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.303 127.38h-20v7h20v-7Z",
    fill: "url(#flumserberg_svg__H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.073 130.07c-3.76.53-8.46.93-8.4 1.55.06.62 5.02-.06 8.78-.6 3.76-.53 6.71-.82 6.68-1.35-.01-.25-3.29-.14-7.06.39v.01Z",
    fill: "currentColor"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M462.053 135.66s5.68 5.99 7.14 8.45c1.46 2.46 6.3 9.53-1.33 7.96-7.63-1.58-15.2-3.41-15.2-3.41l9.38-12.99.01-.01Z",
    fill: "currentColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M464.393 138.29s4.44 4.76 5.5 6.83c1.06 2.06 2.61 4.28 2.04 6.3.51-1.6-7.55-13.13-7.55-13.13h.01Z",
    fill: "currentColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M466.443 146.69c-3.17-2.14-7.24-4.68-7.42-4.46-.46.57 3.41 3.95 6.58 6.09 3.17 2.14 5.93 3.83 6.28 2.97.1-.25-2.27-2.46-5.44-4.6ZM463.313 150.2c-3.65-.84-8.5-1.13-8.82-1.2-1.62-.34 5.11 1.22 8.76 2.07 3.65.84 6.59 1.45 6.62 1.17.03-.28-2.91-1.19-6.56-2.03v-.01Z",
    fill: "currentColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M470.303 133.38h-11v15h11v-15Z",
    fill: "url(#flumserberg_svg__I)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M462.113 136.18s6.51 9.4 5.65 9.73c-.86.33-4.51-1.07-5.2-2.59-.69-1.52-.45-7.14-.45-7.14Z",
    fill: "currentColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M465.303 143.38h-14v8h14v-8Z",
    fill: "url(#flumserberg_svg__J)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M453.663 148.55c1.67.11 6.14.5 7.65.05 1.77-.53 1.95-1.7.49-2.46s-4.03.06-5.32.8-2.83 1.62-2.83 1.62l.01-.01Z",
    fill: "currentColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M474.303 140.38h-18v14h18v-14Z",
    fill: "url(#flumserberg_svg__K)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M466.303 147.05c-3.17-2.14-6.93-5.02-7.31-4.52-.38.5 3.78 3.34 6.95 5.48 3.17 2.14 5.55 3.92 5.89 3.51.16-.2-2.36-2.33-5.52-4.47h-.01Z",
    fill: "currentColor"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M464.173 109.25h-46v44h46v-44Z",
    fill: "url(#flumserberg_svg__L)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M463.173 109.25h-44v43h44v-43Z",
    fill: "url(#flumserberg_svg__M)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M440.993 149.94c10.864 0 19.67-8.623 19.67-19.26 0-10.637-8.806-19.26-19.67-19.26-10.863 0-19.67 8.623-19.67 19.26 0 10.637 8.807 19.26 19.67 19.26Z",
    fill: "currentColor"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M440.993 149.94c10.864 0 19.67-8.623 19.67-19.26 0-10.637-8.806-19.26-19.67-19.26-10.863 0-19.67 8.623-19.67 19.26 0 10.637 8.807 19.26 19.67 19.26Z",
    fill: "currentColor"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M435.683 123.6s.68-3.22 1.35-4.82 1.06-3 1.06-3 1.23.04 4.1.55c2.87.51 3.89 1.02 3.89 1.02l-1.82 7.53 8.97 1.86-1.27 8s-3.31-.77-5.16-1.06c-1.85-.29-4.1-.51-4.1-.51s-.73 2.09-.97 4.36c-.24 2.27-.55 4.78-.55 4.78l-8.12-1.35s-.07-3.11.13-4.82c.21-1.82.72-4.06.72-4.06l-7.87-1.82s.04-1.86.47-4.02c.38-1.94 1.48-3.68 1.48-3.68l7.7 1.06-.01-.02Z",
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M431.133 145.75s0-1.5.25-2.5l.25-1s-2.12-1.56-3.06-2.81-1.81-2-1.81-2l1.62 3.12.31.5s-1-.12-1.69-1.25c-1.2-1.96-1.75-2.19-1.75-2.19l.79 2.46-1.46-1.38-.46-.33.25.94s.77 1.52 2.58 3.27 4.17 3.17 4.17 3.17h.01Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__k",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__N",
    transform: "scale(.08333 .07143)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__l",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__O",
    transform: "scale(.08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__m",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__P",
    transform: "scale(.125 .05263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__n",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__Q",
    transform: "scale(.1 .06667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__o",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__R",
    transform: "scale(.07143 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__p",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__S",
    transform: "scale(.07143 .0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__q",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__T",
    transform: "scale(.07692 .08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__r",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__U",
    transform: "scale(.07692 .08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__s",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__V",
    transform: "scale(.05263 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__t",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__W",
    transform: "scale(.0625 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__u",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__X",
    transform: "scale(.11111 .07143)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__v",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__Y",
    transform: "scale(.05556 .07692)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__w",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__Z",
    transform: "scale(.07692)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__x",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__aa",
    transform: "scale(.1 .07143)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__y",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ab",
    transform: "scale(.1 .05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__z",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ac",
    transform: "scale(.1 .05882)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__A",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ad",
    transform: "scale(.07143 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__B",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ae",
    transform: "scale(.0909 .05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__C",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__af",
    transform: "scale(.0625 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__D",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ag",
    transform: "scale(.11111 .06667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__E",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ah",
    transform: "scale(.05556 .05882)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__F",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ai",
    transform: "scale(.0625 .0909)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__G",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__aj",
    transform: "scale(.08333 .07692)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__H",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ak",
    transform: "scale(.04762 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__I",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__al",
    transform: "scale(.08333 .0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__J",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__am",
    transform: "scale(.06667 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__K",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__an",
    transform: "scale(.05263 .06667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__L",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ao",
    transform: "scale(.02174 .02273)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "flumserberg_svg__M",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flumserberg_svg__ap",
    transform: "scale(.02273 .02326)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__N",
    width: 12,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAAA4klEQVQokZ3RPzKDURQF8N/LKOUbNiChNIxWYwMKbdZgX5qUGgvAElCLQskkoTM5irx88wlp3JlTvPvvnHseGyJJL0lvPV82NDcY1OeklDJb1X5tqFuHuKwYdpm21poLGhzjtKbvMcH0L4YGZxjhAPs4x2DF0jJ0pIzqUIMF9rD944aOlKOKptbneMHH+tFdKUNL96a4xbg6tWilJDlJcpXkLclXkvck10kukuxUBa1LfRxWwEPFGHeYllLSHdith73iCTd4xDNm3WYoSfqWv9rHZ/V83mpei9KxdJnY0Pjv+Aa4/2X1UTPuDgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__O",
    width: 12,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsSAAALEgHS3X78AAAAwUlEQVQokZ3QsU3EQBSE4e9ZztAdogDwpQgoAAlRAKXQGW1wJdAAvg5sE/MIeCtZBhIm2Q1m9p/ZUMrMrt0j4tMfijLvMWCHD4yYIyK3gb5eHvCMG5zwgmNmTttQX+e+zPe4KxK8Yvot0Op1OMcjFpwy8229qQ1dWu8V8baojfYdqPRYvVuFxBWecFj/YKs047iiHXCGS1zjvW3pISIyM6cijFVjwEORLjJzjogMG63wuzInxohYtt4fysxu3f9f+gIErkhhjcOi1wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__P",
    width: 8,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAATCAYAAACtHkzTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAeElEQVQokc2SMQ6AIAxFXwmrLhyA83hur+AFvIAD7talGiyYOPqXJvyXRwiFKqoquISqHIBs8wmoagAyMBkUGgMwGtQa7DAb9Eh0+uSsRGd4f0Wv9EA3fwTUA7EqCrABew8owAwswCoixwUI3F+dLoOINFd1l+VTTmjKJjZvGQ25AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__Q",
    width: 10,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAPCAYAAADd/14OAAAACXBIWXMAAAsSAAALEgHS3X78AAAArklEQVQokZ3RsXECQQwF0KcdUnDgiAgaoAU34EpdgXPXwBD73ADDkSMH3mMOzTnhJ1+z+/frSxuQmWu84oxrRNwUrDKzYYd3/OCUmd8YIyLvws4bvGGLEz7whUsVBl5wwL6fDZl5nGK0EqX1Bzus68WEnNVRh5mEVwydF9F6hgGfnW/F/V/HRfea8cF9vvg6dWJcclzN6hHHXl8U3NeQmRt/+9PbjlVsJm7975/HLzzuQLSXG+h6AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__R",
    width: 14,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAJCAYAAAACTR1pAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoElEQVQokaWRsRHCQBAD94xTQwVgYg85NdAKndEAQx8wxJgCCHhii0TP2GBIUKj5le7uA0tSwRdFRPfhGZoCNVBlL+cBD6AFUj+gdFMNbIHVCNgCe+Ao6RIRCaD0gwpogDUwsZfTG2BueCfpERHKYALOwMztAFeP2bn1BNwiQu87Lj3qxuDBQNfb8z4ADRceedFrTK8rjlx2IEnFr6/5W0+Dyz54hBN2JQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__S",
    width: 14,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAACXBIWXMAAAsSAAALEgHS3X78AAAA6UlEQVQokaXSPU6CQRSF4WcILWBcgC5ALezVHWinG7BxXXaGRrcA7kCtFXbAZ++xYAg/Ab4YbzPJZN57zzszJUkfx+Y1RVNKiZbqVugBPQwxTjJrg7t17eESfRSM2uBujTfEAOe4RzDCbB/YYFynHeEC35gmeSul/GwDOzVOg3d81P0TnKKfpGwFoXb9whNecYg7XGGwCwZJSpKDJDdJXpJM6nqdZLDNUZ2aJDPzS+m1+XZWu/zFdw1s8V288+7a8H1O8pnkMclZks6a42bkFd/gtrouz7RNtvwYMCmlNHvjbjToLCL+u34B/SePCvkyffkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__T",
    width: 13,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAAsSAAALEgHS3X78AAAA40lEQVQokZWSvU7DUAxGj2lWUnYkOqMwtBMSQ0fegpUXY2XoM/QRYGAlZaa0gTU6DDjoNoKhlizrWj7++XRDDaAGZhkDEPgEWmAfEVJYlUUz4B64Ak4SaoFHYK0egANUA5fAdeYAmoxvwBPQD9DQtQNe0r+ACXCWkxugzjN+TA11qs7VO3Wlvqu9ulUf1IU6+V0vIlQ74BnYpAACy1y7SX9VdxFhBZBH9uoHsC6EWqZIt9l0D1gVBeTUMXgDnAOnKRoH0B+gwC5X7vJNjKFSIGAKXGSqBbqI8F+oAIcaxz/jKPsG5ZN29uzWUE0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__U",
    width: 13,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAAsSAAALEgHS3X78AAAA00lEQVQoka3RMUpDURCF4e+GlBJjesUFiJ1lLG0VXIBbcwOSRWQLopaKYCMSYuwUj828+JTYOTAMd7j/cOZM80ckaegySGstqrHp8wAj7GELr3jAqrWW4QZgG/s4wEm957jCG76hAnYwxXlBu7jHExYl0/AXcIyLqiMscVu56naSpCUZJzlNMkvykuSj6qz64xq8ljVIcpjkMslzkvcecJZk8gPo5HV8ufSI61p8jsVaVkXrOTbFEe5wUwYsfwPUnQocYVIurfC5CVhDPbDpXf5f4wvME4fC9Itz6QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__V",
    width: 19,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAJCAYAAADQHRcxAAAACXBIWXMAAAsSAAALEgHS3X78AAAAuUlEQVQokZXSQU4DMQyF4c/VLAGp+4ru4QisuUmP1ZtwC9oLDGIPalnXLHBKVGak8qTIUSL/z44TkJmBtpoSGRHpSkWB7rCuGAU64q1iD5w1GSp5jQ0esaiEd7xg7GBnk8w84tSDh6lqcYsnPODrAtabfGLMzENE5FSbi9o/Y+X3HQM3WOIDB+yxxT4iTkNEZGa2izaEHV6rwh7Wm/x5s7g8YHa6rf37iqq6ET9tTsHmNGHy7+9ztb4BIA1LpZZx6e0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__W",
    width: 16,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAACXBIWXMAAAsSAAALEgHS3X78AAAArUlEQVQokcXRy01CQRQG4O8EXMkjFqCusQISArRAYgM2aAUubUH3ChXIZc1xc24yuSFs+ZPJZBb/c0IhMwNzPGOCE/bocEZGRBogGvID1njFIw74wC/++nsoEo3zFm/YYFbO+4b8js96n3uhcaV4wg6rIgemeKn4C9zX+cJPZnYRkeMmTYdvjIY9kbjDsvY51kbZV5jVeL37JWSlOVa1LiKyHTGukIdCF3/kNvgHvSo82bQ7Rs4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__X",
    width: 9,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAACXBIWXMAAAsSAAALEgHS3X78AAAApklEQVQokY3QwW1CQQwE0OcvrkQRBfxwD7QRpdlI6SGigjQAFEBEOMNysWE/yiFzsbUzHnsnJFprgTkWOOAUEQ0GdwxY4g0joifK5QmvWOG5NxgeXN6xzn6ew4YHl3U6TVbOshmTWObxY9aoNfEHUe+Tm3qi4ZJ1IrrFhV/scSrhrCPP+MEGH9j1opr+xhaf+MKxEo8ugpd03feCOrgSr9+0XvBvXAGd7zLYteb+ywAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__Y",
    width: 18,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2ElEQVQokb3SO07DUBAF0PMQdaKk51NDNoAQaZDS89keSwB6JKoQsYCQ1EB6ULwATJF5yLItS26YzuPn4ztjJz2qLMuElC9TSmW+l9ofaQX2MMBBtD9QZGy/B3CMU1yiwB3e0A0FMgxgghlOovdSP9+AKimGuMBNJBnhC694xGdOQ2VHLWNMcI3zOLLAA5Z4x7ax7I4xxvjGCveYY4ufKgKpgkxxG8AogDWe7JbaSFHfUcIhrnAWb1wEsAqgaEtRh3IVdl/juQ9QH22Ao+ht+gB/EN2//r/XL2tLVrAPzMyvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__Z",
    width: 13,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA1klEQVQoka3SsS5EcRDF4e+/thO7Ef1ata08gMoL8Iaip/AGSDyAUoNSJGvRkXs0c5MbidWYZpKZ+eWck0zzo5I0jNCGY3SttRgu6ngDE8ywVfsOKzzivbWWcQEjTLGHfRwVCEvc4AIfyLgUpjjECRaYYxOvuMJ9weltjZMcJDlN8pzkM8lXkpck50mOk+yUGyrwpCwtsF2zXuGs+rK11g2hWWWYV/DlOqCHtgocZvgVgHH1rhRu/wJ66A13eMAlrtcB0JJMsVt5nrBaB/RQ/zYMXuXf6xvatWyLyGjOjgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__aa",
    width: 10,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAACXBIWXMAAAsSAAALEgHS3X78AAAA10lEQVQokY3RMU5DQQyE4c9PKUmA0AM9iB6JkoqCQ3BAxAVo4AZIKCUkOUBIUtCgmAIvegEK3Ky0+j2esSMzRzjAAquI2PijOhziGhcYZ+YgM+MnOCj4CGfYxzNeMnPZV4/MHOMKN9jBBLd4wFtEZFNcY47AKY5LZI4nfDSPGywxwzv2quEEo+a3gTPc1xulellBO+jKwxrTUk4MCxpW4xfdG//ag7sGtTANnOIOI5xXiNwCIyIzc4nH+l+UnVWDty6QmR12y1/WlFVE/D5VrePbe1v4v+sTt9tQBiJ92CcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ab",
    width: 10,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQokbXSvU4DMRBF4c+GkmSFKIHAg1DxBHlhqOioqSgQP22E2NASUzBeHAfomMpeH507O3bSVSklY45DrLBOKZXcQQkDLrDEGTLsd8Ich8sw3iL9Bg44b/bbi4idhXFeP++AsV7gMmJfsK5wDw44xSuu8YTNBHaxszA91tG0xj72GW/V1oLVePJTbA/uxf49oCkWctPfAgdh+WhHU41/jqUFq/HY1yO46vvj+woLxgDuMLb9VbDEKG5wj4focatS8zNHMZoxpbTZAZluJqH0kf9XnzUOS5/iCWzSAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ac",
    width: 10,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAARCAYAAADkIz3lAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQokZXSu04DMRCF4W82aTcLHRW3DsEjABUPACUFTwr0SGkRLRJKi4RICcQUGa+WsBScxrb8+8zMkcOISimBQImIAs0I1KDDHtp89BNMaBtnuEy4gekIdI7rvJtnC2s67bt0usm1q9DQcYIDXOE0gQWWWA+TbjMc4yT3C9zjBatausEuLrCf52VCy2E8gTbhtuaXTqX2+CvHv9Tkq77U0GUTXCV0h2d8jMHTiCillHc84gGfeKvTVgV94DMc4gg7uMVTRHz14ACe5ORbeDWIJ2xo7Iv9S988Vk423kWIZgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ad",
    width: 14,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0klEQVQokY3SPU7DQBCG4WfAbZA4AEpaFIQ4ABUSB+GGIGqKkIOgpKCNQ2jtoRkjE1nANKv9ed+d/bQBmRk4QSDRR0T6paKgMywwwye2OJRkUtTUTXM8YIl3vBTclWCTmfuI6MeganFW4A2uC+iwwSPWmbkb4AZ92Z9xjltcVidwVU+BVWa2EZFNRGRm7rGuzUMdXhQwyFq84QNdAxHRZ+YOq7p9ifsa59XVz1THk0r4dJTyEneV7BNe0UZEhok6ElzU8hbfyU6CR4IhpD8/xb/qCwo2VBzlWBFgAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ae",
    width: 11,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6ElEQVQokY3TMU7DQBCF4W8NbRwBJYJAgYTEFajgAnBSTgC3iERHCKIMCFInSzOOzHotZaSVt3jz9v2jcYKcc0JCTillI9WEcIIZpjnnZlQcZ4YH3EZDGhMnTEP4iEscjIlFQ4ubOG3NvUHGGp84wT3Oe0b/xFss8YJvnEWsoThGtcZ7fLvJTMooXfcWP/jAUUS5KEH74iWe8YXrGmgDEeUXc7ziuAbah9hgEe5V0N1lH9ByPCXoXT9KTdyBrnAaLwydC9B53Hcre2hYG7zhCVcRK+vsy4qdbiP3CuuUUn1vo2Gvv2e0/gB1NVZ5/IVNiwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__af",
    width: 16,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAAAsSAAALEgHS3X78AAAAyUlEQVQoka3SQUoDQRCF4a/ibGPiUnDMBTyDkJN4NcETeId4ARHcR9xGo2vTbl5CHERmYW2Kbuqvqve6y8horRUmOe6qqkGNhCY4xQUa1thWVetGQD3mWOAaH7jFE766EdAyeY5zPKamoAs8S9HZL1AfAN7wis9I0WXqAje4SpPLQB1OUrzBA+7jwW7f4IcF0ficrXpMscUKd8nvh1cYSJhF2yRbLOP8SyavsKmq3X5iDUyso/u9mdNoXmfyAeaPfzBo2hx9nn+NbydUQtyGvfq6AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ag",
    width: 9,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAACXBIWXMAAAsSAAALEgHS3X78AAAAxElEQVQokY3RO05DQQyF4W9GkagIYQEQCigiwQaoWAsrYwlsgIItUFEgIR51BJeWzFBwbnSRUmBpdOzxL1u2C/TeCyoKOloppYuVAAdYYo4BL/gcwVkqLHGNFR5xgwd8C1BxiAtc5p1jni4q9nGEBfZwgiscJ68meRotdljFB56iG7zhPtpG6Avv0ZbpXjGM09VxL9Geapv423YmyW2VKTRLMOA54F3ANoVaPm9xliUOf84Cvffq9zQLrHdCAUviPgX+bT9Mikhr3SJlwAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ah",
    width: 18,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAACXBIWXMAAAsSAAALEgHS3X78AAAA9ElEQVQ4jcXUu0oDQRQA0HNXaw3WKrY+sLAU/QCxsVf8O3sN5AtULCxVsBTENsSkTtZiZzFsdtkkFt5umOEw9zETFow8zwNZWk4iIodYEFjBGjYxwSeGEZGvzolk6GAH+zjCB7oYoR1KyAZOcIFdfOMZA+T85tqGnOIaZ9jGF94xKmvUCFWQKxynrSfcpdTG5fnaYleQSxymdN5wiwf0I2LSCNUgBwno4iXdZDCNzEANyCtucK8o7risSy00B9Kv3mIG+isCWZrYjmJOlkIo2p9hC+fYWwaB6cke4hE9Ne1ti0iprSsmNhQPcaa9rRDNX8O/xA+pKXF3ClIGJwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ai",
    width: 16,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQokZXSTUoDQRDF8V8Ns1WjBzBrURH36lHEo3kSXSheQPeSBFxKEtdJubAmjPErFjQ0BfXv915XQGYGGgQSy4hIG1TU8A6G2MYbJphj+ResrZeHuMIhXnCLEaaYZOaPsLZ338IRTnFSw6M12Lhgiw7UWdjFBS5xhkFB52Wng93gEc+YRUS2EZGZOcV9hQjn2KszKPnHOMADrvGERQsRsczMV9z1LHVKwi+1ymANkphVuE0pGPcsjKr3lZ6ZTb287+Nbu92YF+RziN/JWlusVds/FmzjegfeS1+SaW38BQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__aj",
    width: 12,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAACXBIWXMAAAsSAAALEgHS3X78AAAA10lEQVQokZ3RPU4DQQzF8Z+XLSGsQokIHCQFN+AGHI0mF4AzADdAgo4PUVFEiUJJdmg8aDeIhmmeZP2f/ewJO6+UEmgQtYQ+IopBscINOswwyfIar1hHRGl34CnmuMBpdn/AVeq2HcToEr5M7fCFPqeFzFp1lp3nOMIePvGOTU4bGTqcpcISd7jBW07SZJxJZj4cwLdYpGlVr9Rm9xOc4xirhBZpWkZEX4/T5jL7OMAznnCdphFcDSVvfY8PPOIlY4xgiMEO04yzwbZm/mXg5x8C5S/w3+8bMHJKa5bThNYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ak",
    width: 21,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAICAYAAAAWX7TTAAAACXBIWXMAAAsSAAALEgHS3X78AAAApElEQVQokb3ROXICQQwF0Cc8qZcDsBzAl/BNuKoP4NDOXZCDGTsFkaipKQo69E9Urb+UWgodZGZghujpkDhFRGriO+bAExZVbwUnjjhgizEicqjAZ6yqNvMMS7xhfiM08YtvfOKv3jmUeYU1XvEwmfQRL/hphqvQHT4qdN/44d6SSnDAF96xwemKH6s/4njZaef7U+O26nTSxl8O1NA7VNf47zgD7X0+qDMllYIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__al",
    width: 12,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQokYXSPU4DQQwF4G8mqVerHADSIpEeoXQcAI7KCSgQN4Aekh7lB4mKxBTrSAski6XReCQ/v+c3LhARBQVRSgkDUbO4wTnaiKiDgDxnuMUckyHQOKW0WXyNER4jYnVM3rjHNMEFPrHEFl/HJPXzFjNcosn5TgKknClu8h6dAgT2mTfJcJSlZvG2p7sOsdTsvMQDFvk+sMz8+pua1m3xgmesdVZPcaezuz1IO9i6wxvus/s87yu84xUb7MZQSomIWOMpG2x0q7LHR3+GHw6k1la3Kk0PvMCmlPL3Y1Jr7TUL7P/b4pPxDczHU9chY/WeAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__am",
    width: 15,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAJCAYAAADtj3ZXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoElEQVQokaXRsU0DQRCF4W/OFx8d+HAMFODU7sM1Wm7BPRBjKAC4nFuSMTqvVnLAS0Y70v/m7UxoqJQS6BDLNuaIKNdGNKAVBqyzRoIT3vEVEfMfXEGPeMYuDTrMuOCIMz4jovQJPmCDF+wTHqvJT2nyhm/89Ok84oBtmgyZ5OZbtfpqIRNeG9A19gkf+RaL2GPW1rS7C6tP0zK4OdW/9AvHqjYlXGrcrQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__an",
    width: 19,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAAACXBIWXMAAAsSAAALEgHS3X78AAABGUlEQVQ4jZ3USy5EYRCG4afkTF1ijBi7zTE0lLABi2QHgsQCXGZCegF0Y0iXwSl0pA/dalSVVN7/+6r+VEBmBmYQSAwjIk0ZUaA5rGAer+jhGe/TQJtSs4g97OIFp7jGQ2b2I2I4KSzRxx22C7iJGxzjIjP7k6hsIiIzc4DLgjfYwZLW/jyuJlHZQEQMM/MR56X0BevYwvIPlY9dwOYzGQGeaRewicOyvoRZ7XzPu2w3o0UBn7Sb7GFQ+XrBj8r6WNvR5T8zZ7CA1QIdYEO7rFuc4AJftpuxpG6Vh1jTLmi2Ws8y8ykishNWwMTbmFkeFHQf9/XQ+6+wP1TuV/3dNwlsNEZmuaz9Rj0MIiKnhhXw8zDwz6PwZ3wAjXWUUZgMVHMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ao",
    width: 46,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAsCAYAAAAacYo8AAAACXBIWXMAAAsSAAALEgHS3X78AAAA50lEQVRYhe2Z3RWCMAxGi0s4iEs4sks4iFPg0+ep2EDS1vxwch+hhZvvAU6TpQxyvd1X7trX87GMvg90PUgiSzFaBHvzDFmKniJYG/4pXSMpYHehlvAWTgHkAitpcCTfvGktDfbkf254kQaU/NdFb9KgJX+xEJnBpxKvaYNt6rET9542qFOPm3iUtAFSD5t4imuT4lrgYxJOHKS4NimuTTjx/OVbEVY8DxLa5GFZm2wIaXOO3iHwIi/q1gJr+a7+OAg5kQDa8tw5kIupWynyyZt4TDezgJFZ59CQVFqE+WSZolXITNmaN91lZEFr0R/RAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "flumserberg_svg__ap",
    width: 44,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAArCAYAAAADgWq5AAAACXBIWXMAAAsSAAALEgHS3X78AAAA70lEQVRYhe2Z2w2DMAxFjZdgEJZg5C7RQToF/bpSCnknTuwq5w/lweESLAhEAuzHee3HeUnMvbUMLpH6vF9N5wJFk/RKrUU+a6DU7QUlF5DsKC0LcqWDnUaJ3kmJextnyYKY9KNhtiwISbN7oEU2Bqe7zCEU3pbqMJv70mAivbI+1C4JcA+TLaVLZCBhot+UTQi7LGFpzAhjHZsRBktYmiUszRKWxoww3ovNCIMlLIH7mcS9NulGoT5h70eopZRVJ+wLkmONGjG3t2Z/9xKY2h8Go6VznqP/+8cBekvXVqXqUlZzAT1KZ5faG5PvXd+/NHdfZ4DxeAgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__b",
    x: 452.119,
    y: 86.678,
    width: 10.465,
    height: 25.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__c",
    x: 469.12,
    y: 136.129,
    width: 23.825,
    height: 14.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__d",
    x: 405.331,
    y: 147.442,
    width: 20.494,
    height: 19.114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__e",
    x: 398.155,
    y: 100.648,
    width: 26.494,
    height: 20.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.54
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__f",
    x: 459.233,
    y: 149.507,
    width: 12.357,
    height: 30.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.54
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__g",
    x: 426.459,
    y: 88.119,
    width: 12.327,
    height: 24.71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.56
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__h",
    x: 392.712,
    y: 134.988,
    width: 26.218,
    height: 5.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.52
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__i",
    x: 460.382,
    y: 112.188,
    width: 37.763,
    height: 13.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "flumserberg_svg__j",
    x: 429.842,
    y: 147.272,
    width: 14.786,
    height: 37.718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_550_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_550_1173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flumserberg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h504v185H0z"
  })))));
};
export default SvgFlumserberg;